import styled from 'styled-components'

export const WalletSwapper = styled.article`
  overflow: hidden;
  margin: 14px 0;
  border: 1px solid #e2edf0;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 10px 28px rgba(27, 66, 79, 0.07);
  transition: transform .22s ease, box-shadow .22s ease;
  &:hover { transform: translateY(-2px); box-shadow: 0 16px 34px rgba(27, 66, 79, .11); }
`

export const WalletTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 15px 20px;
  border-bottom: 1px solid #ebf1f3;
  color: #21405b;
  font-size: 14px;
  font-weight: 800;
  background: linear-gradient(90deg, #f3fdfd, #fff);
  .number { display: grid; width: 26px; height: 26px; place-items: center; border-radius: 8px; color: #fff; font-size: 12px; background: #1fc7d4; }
`

export const WalletItem = styled.div`
  display: grid;
  grid-template-columns: 100px minmax(0, 1fr) auto;
  gap: 16px;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eff3f5;
  &:last-child { border-bottom: 0; }
  .left { color: #638096; font-size: 13px; font-weight: 700; }
  .center { min-width: 0; color: #31445d; font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; font-size: 12px; line-height: 1.65; overflow-wrap: anywhere; }
  .right { display: inline-flex; min-width: 64px; min-height: 32px; padding: 0 10px; align-items: center; justify-content: center; gap: 5px; border: 1px solid #cae7e9; border-radius: 9px; color: #168e98; font-size: 12px; font-weight: 700; background: #f3fdfd; cursor: pointer; }
  .right:hover { border-color: #1fc7d4; background: #def8f7; }
  .right:active { transform: scale(.96); }
  @media (max-width: 768px) { grid-template-columns: 1fr auto; gap: 8px 12px; padding: 14px 15px; .left { grid-column: 1; } .center { grid-column: 1 / -1; grid-row: 2; padding: 9px 10px; border-radius: 9px; background: #f7fafb; } .right { grid-column: 2; grid-row: 1; } }
`
